import React from "react";
import { useParams } from "react-router-dom";
import { RouteParamsContext } from "./RouteParamsContext";

export const RouteParamsProvider = ({ children }) => {
  const { projectName } = useParams();  

  return (
    <RouteParamsContext.Provider value={{ projectName }}>
      {children}
    </RouteParamsContext.Provider>
  );
};
